import React from 'react';
import { Link } from 'react-router-dom';
import bgimage from '../../Assets/bgh.jpg';

export default function NewHome() {

  return (
    <div className="relative pt-20 md:pt-40 px-4 md:px-20 flex flex-col md:flex-row justify-center">
      <div
        className="absolute top-0 left-0 w-full z-[-1] h-[60vh] md:h-[80vh]"
        style={{
          backgroundImage: `url(${bgimage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          opacity: 0.8,
        }}
      ></div>


      <div className="max-w-lg pt-4 text-center md:text-center mb-10 md:mb-0">
        <h1 className="text-4xl md:text-5xl text-[#121A31] font-bold leading-tight mb-6">
          <span className="text-2xl md:text-3xl text-zinc-800 font-medium">We.</span> <br /> Just Design <br />
        </h1>
        <p className="text-base md:text-lg text-white mb-6">
          We gain practical insights before sharing solutions. We develop strategies rooted in real-world experience.
        </p>
        <div className="flex flex-col md:flex-row items-center justify-center">
          <Link to={'/contactus'}>
            <button className="bg-[#2E3944] text-white px-6 py-3 rounded-md text-base md:text-lg font-medium shadow-md hover:bg-gray-800 mb-4 md:mb-0 md:mr-4">
              Get started
            </button>
          </Link>
          <p className="text-sm px-6 py-3 text-white font-medium">
            IT'S FREE
          </p>
        </div>
      </div>
    </div>
  );
}
